import React from "react";
import { Navigate } from "react-router-dom";
import { useUserRole } from "../utils/helperMethods";
import { getLibraryRequestsPathForRole } from "../utils/libraryRequestsEmailLinkPaths";
import LoadingModal from "../components/Skeletons/LoadingModal";

/**
 * Fallback for document-request email deep links when the URL targets another portal.
 * Example: a Backend User opens /Assessment/Requests → /Request/Library.
 */
const LibraryRequestsEmailLinkRedirect = () => {
  const userRole = useUserRole();

  if (!userRole) {
    return <LoadingModal open={true} />;
  }

  return <Navigate to={getLibraryRequestsPathForRole(userRole)} replace />;
};

export default LibraryRequestsEmailLinkRedirect;
